import { Button } from '@/components/ui/button';
import * as Card from '@/components/ui/card';
import { Text } from '@/components/ui/text';
import dayjs from 'dayjs';
import { For, createMemo } from 'solid-js';
import { useService } from 'solid-services';
import { css } from 'styled-system/css';
import { Flex, Grid } from 'styled-system/jsx';
import { useCalendarState } from '../../../state/events/calendar-state';

export default function WeekView() {
  const { viewDate, days, setActiveEvent } = useService(useCalendarState)();

  const displayedDays = createMemo(() => {
    const allDays = days();
    const targetDate = viewDate();
    const activeIndex = allDays.findIndex((d) => d.date.isSame(targetDate, 'day'));

    if (activeIndex === -1) return allDays.slice(0, 7);
    const weekStartIndex = Math.floor(activeIndex / 7) * 7;
    return allDays.slice(weekStartIndex, weekStartIndex + 7);
  });

  return (
    <Grid gridTemplateColumns="1fr" gap={3} height='100%'>
      <For each={displayedDays()}>
        {(day) => {
          const isToday = day.date.isSame(dayjs(), 'day');

          return (
            <Card.Root
              class={css({
                p: 3,
                border: isToday ? '2px solid' : 'none',
                borderColor: isToday ? 'jade.10' : '',
                display: 'grid',
                gap: 3,
                gridTemplateColumns: '50px 1fr',
              })}
            >
              <Text
                fontWeight={isToday ? 'bold' : 'normal'}
                textAlign="left"
                color={isToday ? 'accent.default' : 'fg.default'}
              >
                {day.date.format('ddd D')}
              </Text>

              <Grid gap={2} alignContent='start'>
                <For each={day.events}>
                  {(event) => (
                    <Button
                      colorPalette='jade'
                      variant="outline"
                      size="sm"
                      p={2}
                      h='auto'
                      onClick={() => setActiveEvent(event)}
                      class={css({ justifyContent: 'flex-start', whiteSpace: 'normal' })}
                    >
                      <Grid w='100%' gap={1}>
                        <Text truncate fontSize='sm' fontWeight='bold' textAlign='left'>
                          {event.group}
                        </Text>
                        <Flex justifyContent='space-between' alignItems='center'>
                          <Text fontSize='xs' color='fg.muted'>{event.duration_mins}m</Text>
                          <Text fontSize='xs' color='fg.muted'>{event.localTime.format('HH:mm')}</Text>
                        </Flex>
                      </Grid>
                    </Button>
                  )}
                </For>
              </Grid>
            </Card.Root>
          );
        }}
      </For>
    </Grid>
  );
}
